<template>
  <v-layout row>
    <v-flex xs12 sm12 offset-sm>
      <v-card>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="headline text-xs-center">
             Common Team Management 
          </v-toolbar-title>
          <v-spacer></v-spacer>  
          <v-card-actions class="justify-center">
            <v-btn 
              @click="getFirms"
              outlined>
              <v-icon left color='teal'> add </v-icon> 
              New Account  
            </v-btn>
          </v-card-actions>
        </v-toolbar>  
        
        <v-card>
            <template v-for="(item, index) in getStaffAccount">
              <v-divider :key="item['.key']"></v-divider>
              <v-card :key="index">
                <v-card-title class="body-1 primary--text font-weight-light" col>
                  <v-flex xs11> 
                    Firm:  &nbsp; <b class="font-weight-bold">{{firmbyId(item.firm)}}</b>  
                    <v-spacer/>
                    Account Name: &nbsp; <b class="font-weight-bold">{{item.staffName}}</b> 
                    <v-spacer/>
                    Account Role: &nbsp; <b class="font-weight-bold">{{item.staffRole}}</b>
                    <v-spacer/>
                    Opening Balance: &nbsp; <b class="font-weight-bold">{{item.openingBalance}}</b>
                     <!-- <v-spacer/>
                    Brokerage Rate: &nbsp; <b class="font-weight-bold">{{item.brokerageRate}}</b> -->
                  </v-flex>

                  <!-- <v-flex xs1>
                  </v-flex>
                  
                  <v-flex xs5> 
                    Account Role: &nbsp; <b class="font-weight-bold">{{item.staffRole}}</b>
                    <v-spacer/>
                    Opening Balance: &nbsp; <b class="font-weight-bold">{{item.openingBalance}}</b>
                  </v-flex> -->

                  <v-flex xs1>
                    <v-btn flat icon class="primary white--text" @click="editStaffAccount(item)">
                      <v-icon color="grey white--text">edit</v-icon>
                    </v-btn>  
                    <v-btn flat icon class="primary white--text" @click="deleteStaffAccount(item['.key'])">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-card-title>
                <!-- <v-card-actions>
                  <v-btn flat icon class="primary white--text" @click="editStaffAccount(item)">
                    <v-icon color="grey white--text">edit</v-icon>
                  </v-btn>  
                  <v-btn flat icon class="primary white--text" @click="deleteStaffAccount(item['.key'])">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-card-actions> -->
              </v-card>
            </template>
          </v-card>
        </v-card>
    </v-flex>

    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title primary title class="primary white--text">
           <span class="headline">Add New Account Account</span> 
        </v-card-title>
        <v-card-text>
          <v-select
          item-text="name"
          item-value="id"
          :items="items"
          v-model="currentFirm"
          label="Select Firms"
        ></v-select>
          <v-text-field label="Account Holder Name" v-model="staffName" ></v-text-field>
          <v-select
          item-text="name"
          item-value="id"
          :items="currentStaffRole"
          v-model="staffRole"
          label="Choose Account Role"
        ></v-select> 
          <!-- <v-text-field label="Opening Balance" v-model="openingBalance" ></v-text-field> -->
          <v-text-field label="Opening Balance" v-model="openingBalance"></v-text-field>
          <v-text-field v-if="staffRole === 'Commission'" type="Number" label="Brokerage Rate" v-model="brokerageRate"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="cancelDialog">
            Cancel
          </v-btn>
          <v-btn color="green darken-1" flat="flat" @click="addNewStaffAccount">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="dialogEdit" persistent max-width="400">
      <v-card>
        <v-card-title primary title class="primary white--text">
           <span class="headline">Edit Account Account</span> 
        </v-card-title>
        <v-card-text>
          <v-select
          item-text="name"
          item-value="id"
          :items="itemsEdit"
          v-model="currentFirmEdit"
          label="Select Firm"
        ></v-select>
          <v-text-field label="Account Holder Name" v-model="staffNameEdit" ></v-text-field>
          <v-select
          item-text="name"
          item-value="id"
          :items="currentStaffRole"
          v-model="staffRoleEdit"
          label="Choose Account Role"
        ></v-select> 
          <!-- <v-text-field label="Opening Balance" v-model="openingBalance" ></v-text-field> -->
          <v-text-field label="Opening Balance" v-model="openingBalanceEdit"></v-text-field>
          <v-text-field v-if="staffRoleEdit === 'Commission'" type="Number" label="Commission Rate" v-model="brokerageRate"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="cancelDialogEdit">
            Cancel
          </v-btn>
          <v-btn color="green darken-1" flat="flat" @click="updateNewStaffAccount">
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-snackbar
      v-model="snackbar"
      top
      color="error"
      :timeout="3000"
    >
   {{snackbarText}}
    </v-snackbar>
    <v-snackbar
      v-model="snackbarSuccess"
      top
      color="success"
      :timeout="3000"
    >
   {{snackbarSuccessText}}
    </v-snackbar>
  </v-layout>

</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import { debug, debuglog } from 'util';

const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
export default {
  name: 'Staff',
  data () {
    return {
      // getStaffAccount: [],
      dialog: false,
      dialogEdit: false,
      items:null,
      currentFirm:"",
      currentStaffRole:[
        'Normal A/C',
        'Accountant',
        'Commission',
        'Director',
        'Manager',
        'Supervisor',
        'Operator',
        'Salesman',
        'Trader',
        'Helper',
        'Personal',
        'Not to disclose'
      ],
      staffName: null,
      brokerageRate : 0,
      staffRole: null,
      staffNameEdit: null,
      staffRoleEdit: null,
      firms: [],
      openingBalanceEdit:0,
      openingBalance:0,
      initialamount:0,
      snackbarSuccessText:null,
      snackbarText:null,
      snackbar : false,
      snackbarSuccess:false,
      currentFirmEdit:null,
      itemsEdit:null,
    }
  },
  created () {
    this.$bindAsArray(
      'firms',
      this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'account',
      this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'staff',
      this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand)
    )
  },
  computed: {
    ...mapGlobalGetters(['selectedBrand']),
    getStaffAccount () {
      if (this.selectedBrand) {
        return this.staff.filter(item => item['brand'] === this.selectedBrand && item['firm'] != '')
      }
    },
    staffCount () {
      return this.getStaffAccount.length || 0
    }  
  },
  methods: {
    firmbyId(id){
      return this.firms.filter(item => item['.key'] == id)[0].name
    },
    addNewStaffAccount () {
          let data ={
            brand:this.selectedBrand,
            firm:this.currentFirm,
            staffName:this.staffName,
            brokerageRate : this.brokerageRate,
            openingBalance:this.openingBalance,
            amount:this.initialamount,
            staffRole:this.staffRole,
          }
      if(data.firm == null || data.firm == ""){    
        this.snackbar = true;
        this.snackbarText = 'Please Select Firm';
        return false;
      }else if(data.staffName == null || data.staffName == ""){    
        this.snackbar = true;
        this.snackbarText = 'Enter Account Holder Name';
        return false;
      }else if(data.staffRole == null || data.staffRole == ""){    
        this.snackbar = true;
        this.snackbarText = 'Please Select Account Role';
        return false;
      }    

          this.$root.$firebaseRefs.staff.push(data);
          // this.addInvoice();
          this.dialog=false;
          this.currentFirm="";
          this.staffName="";
          this.brokerageRate= 0;
          this.openingBalance=0;
          this.amount=0;
          this.staffRole="";
    },
    editStaffAccount(key){

      this.dialogEdit = true;
      console.log(key)
      let firms = this.firms.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        firms.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.itemsEdit = totalitem;

      this.dialogEdit=true;
      this.currentFirmEdit= key.firm;
      this.staffNameEdit=key.staffName;
      this.brokerageRate = key.brokerageRate;
      this.staffRoleEdit=key.staffRole;
      this.staffOpeningBalanceEdit=key.openingBalance;
      this.updateKey=key['.key']
    },
    updateNewStaffAccount(){
      let data ={
          brand:this.selectedBrand,
          firm:this.currentFirmEdit,
          staffName:this.staffNameEdit,
          brokerageRate: this.brokerageRate,
          staffRole:this.staffRoleEdit,
          openingBalance:Number(this.openingBalanceEdit),
        }
        this.$root.$firebaseRefs.staff.child(this.updateKey).update({
          brand:this.selectedBrand,
          firm:this.currentFirmEdit,
          staffName:this.staffNameEdit,
          brokerageRate : this.brokerageRate,
          staffRole:this.staffRoleEdit,
          openingBalance:Number(this.openingBalanceEdit),
        });
        // this.addInvoice();
        this.currentFirmEdit="";
        this.bankNameEdit="";
        this.staffNameEdit="";
        this.brokerageRate = 0;
        this.staffRoleEdit="";
        this.openingBalanceEdit=0;
        this.cancelDialogEdit();
    },

    deleteStaffAccount(key){
      confirm('Are you sure you want to delete this Account') &&
      this.$root.$firebaseRefs.staff.child(key).remove();
    },
    cancelDialog(){
      this.dialog = false;
    },
    cancelDialogEdit(){
      this.dialogEdit = false;
    },
    getFirms () {
        this.dialog =true;
        let firms = this.firms.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        firms.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.items = totalitem;
        this.itemsEdit = totalitem;
    },
    getStaffAccount () {
      this.dialog =true;
        let staff= this.staff.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        staff.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.items = totalitem;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Settings/Staff/index.vue